"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tether = exports.useTetherStyles = void 0;
var tslib_1 = require("tslib");
var rect_1 = require("@reach/rect");
var lodash_1 = require("lodash");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var theme_1 = require("../../theme");
function cssValueToString(val) {
    if ((0, lodash_1.isNumber)(val)) {
        return "".concat(val, "px");
    }
    return val;
}
function getPopoverTransform(anchor) {
    if (anchor === 'top') {
        return 'translate(-50%, 0%)';
    }
    if (anchor === 'topRight') {
        return 'translate(-100%, 0%)';
    }
    if (anchor === 'right') {
        return 'translate(-100%, -50%)';
    }
    if (anchor === 'bottomRight') {
        return 'translate(-100%, -100%)';
    }
    if (anchor === 'bottom') {
        return 'translate(-50%, -100%)';
    }
    if (anchor === 'bottomLeft') {
        return 'translate(0%, -100%)';
    }
    if (anchor === 'left') {
        return 'translate(0%, -50%)';
    }
    if (anchor === 'center') {
        return 'translate(-50%, -50%)';
    }
    return 'translate(0%, 0%)';
}
function calc(value, offset) {
    return "calc(".concat(value, "px + ").concat(cssValueToString(offset), ")");
}
function calculatePositionStyles(_a) {
    var targetRect = _a.targetRect, _b = _a.targetAnchor, targetAnchor = _b === void 0 ? 'bottomLeft' : _b, _c = _a.anchor, anchor = _c === void 0 ? 'topLeft' : _c, _d = _a.xOffset, xOffset = _d === void 0 ? 0 : _d, _e = _a.yOffset, yOffset = _e === void 0 ? 0 : _e, _f = _a.width, width = _f === void 0 ? 'auto' : _f, _g = _a.zIndex, zIndex = _g === void 0 ? theme_1.zIndices.tether : _g, _h = _a.position, position = _h === void 0 ? 'fixed' : _h;
    var transform = getPopoverTransform(anchor);
    var sharedProperties = {
        position: position,
        transform: transform,
        width: width || 'auto',
        zIndex: zIndex,
    };
    if (targetAnchor === 'topLeft') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top, yOffset), left: calc(targetRect.left, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'top') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top, yOffset), left: calc(targetRect.left + targetRect.width / 2, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'topRight') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top, yOffset), left: calc(targetRect.right, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'right') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top + targetRect.height / 2, yOffset), left: calc(targetRect.right, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'bottomRight') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.bottom, yOffset), left: calc(targetRect.right, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'bottom') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.bottom, yOffset), left: calc(targetRect.left + targetRect.width / 2, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'bottomLeft') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.bottom, yOffset), left: calc(targetRect.left, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'left') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top + targetRect.height / 2, yOffset), left: calc(targetRect.left, xOffset) }, sharedProperties);
    }
    if (targetAnchor === 'center') {
        return (0, tslib_1.__assign)({ top: calc(targetRect.top + targetRect.height / 2, yOffset), left: calc(targetRect.left + targetRect.width / 2, xOffset) }, sharedProperties);
    }
    throw new Error('Invalid anchor');
}
function useTetherStyles(targetRef, options) {
    var anchor = options.anchor, xOffset = options.xOffset, targetAnchor = options.targetAnchor, yOffset = options.yOffset, width = options.width, zIndex = options.zIndex, position = options.position;
    var targetRect = (0, rect_1.useRect)(targetRef);
    var _a = (0, react_1.useState)({}), styles = _a[0], setStyles = _a[1];
    (0, react_1.useEffect)(function () {
        if (!targetRect) {
            return;
        }
        setStyles(calculatePositionStyles({ targetRect: targetRect, targetAnchor: targetAnchor, xOffset: xOffset, yOffset: yOffset, anchor: anchor, width: width, zIndex: zIndex, position: position }));
    }, [targetRect, targetAnchor, xOffset, yOffset, anchor, width, position]);
    return styles;
}
exports.useTetherStyles = useTetherStyles;
function Tether(props) {
    var children = props.children, targetRef = props.targetRef, testId = props.testId, _a = props.targetAnchor, targetAnchor = _a === void 0 ? 'bottomLeft' : _a, _b = props.yOffset, yOffset = _b === void 0 ? 0 : _b, _c = props.xOffset, xOffset = _c === void 0 ? 0 : _c, _d = props.anchor, anchor = _d === void 0 ? 'topLeft' : _d, width = props.width, zIndex = props.zIndex, position = props.position;
    var styles = useTetherStyles(targetRef, {
        targetAnchor: targetAnchor,
        yOffset: yOffset,
        xOffset: xOffset,
        anchor: anchor,
        width: width,
        zIndex: zIndex,
        position: position,
    });
    return (react_1.default.createElement("div", { style: styles, "data-testid": testId }, children));
}
exports.Tether = Tether;
//# sourceMappingURL=index.js.map